import React, { useState, useEffect } from "react";
import axios from "axios";
import getAPI from "../../service/getAPI";
import { Table, Form, Button } from "react-bootstrap";

function UnicommerceData() {
  const { master } = getAPI();
  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [trackOnly, setTrackOnly] = useState(false);

  const [filters, setFilters] = useState({
    order_code: "",
    tracking_number: "",
    shipping_courier: "",
    order_date: "",
    customer_name: "",
    phone_number: "",
    product: "",
    address: "",
    state: "",
    pincode: "",
  });

  const [dateFilter, setDateFilter] = useState({
    fromDate: "",
    toDate: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      let res = await axios.post(master.unicommerce_order_list, {});
      setList(res.data.data);
      setFilteredList(res.data.data);
      setCurrentPage(1);
    } catch (err) {
      console.error(err);
    }
  };

  const filterByDate = async () => {
    try {
      // Fetch data by the selected date range
      let res = await axios.post(master.unicommerce_order_list, {
        fromDate: dateFilter.fromDate,
        toDate: dateFilter.toDate,
      });

      // Store data filtered by date range
      setList(res.data.data);
      setFilteredList(res.data.data); // Initially apply date filter to list
      setCurrentPage(1); // Reset pagination to the first page
    } catch (err) {
      console.error(err);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
    setFilteredList(applyFilters(list));
    setCurrentPage(1); // Reset pagination to first page after applying filter
  };

  // This function will apply the date and tracking number filters
  // const applyFilters = (data) => {
  //   let filteredData = data;

  //   // Apply the date range filter if available
  //   if (dateFilter.fromDate && dateFilter.toDate) {
  //     filteredData = filteredData.filter((item) => {
  //       const orderDate = new Date(item.order_date);
  //       const fromDate = new Date(dateFilter.fromDate);
  //       const toDate = new Date(dateFilter.toDate);
  //       return orderDate >= fromDate && orderDate <= toDate;
  //     });
  //   }

  //   if (trackOnly) {
  //     filteredData = filteredData.filter(
  //       (item) => item.tracking_number && item.tracking_number.trim() !== ""
  //     );
  //   }

  //   // Apply other filters like customer name, product, etc.
  //   Object.keys(filters).forEach((key) => {
  //     const value = filters[key].trim().toLowerCase();
  //     if (!value || key === "tracking_number") return; // Skip empty filters
  //     filteredData = filteredData.filter((item) =>
  //       item[key].toString().toLowerCase().includes(value)
  //     );
  //   });

  //   return filteredData;
  // };

  const applyFilters = (data) => {
    let filteredData = data;

    // ✅ Filter by Date Range (From - To)
    // if (dateFilter.fromDate && dateFilter.toDate) {
    //   const fromDate = new Date(dateFilter.fromDate);
    //   const toDate = new Date(dateFilter.toDate);

    //   filteredData = filteredData.filter((item) => {
    //     if (!item.order_date) return false;

    //     const orderDate = new Date(item.order_date);
    //     if (isNaN(orderDate)) return false;

    //     return orderDate >= fromDate && orderDate <= toDate;
    //   });
    // }

    // ✅ Tracking Number only filter
    if (trackOnly) {
      filteredData = filteredData.filter(
        (item) =>
          item.tracking_number && item.tracking_number.toString().trim() !== ""
      );
    }

    // ✅ Text filters (like order_code, customer_name, etc.)
    Object.keys(filters).forEach((key) => {
      const filterValue = filters[key].trim().toLowerCase();
      if (!filterValue) return;

      filteredData = filteredData.filter((item) => {
        const itemValue = item[key];

        if (itemValue === null || itemValue === undefined) return false;

        // Special case for order_date — compare DD/MM/YYYY format
        if (key === "order_date") {
          const formattedDate = new Date(itemValue).toLocaleDateString("en-IN"); // 'dd/mm/yyyy'
          return formattedDate.includes(filterValue);
        }

        return itemValue.toString().toLowerCase().includes(filterValue);
      });
    });

    return filteredData;
  };

  useEffect(() => {
    setFilteredList(applyFilters(list));
  }, [trackOnly, filters, list]);

  const handleCheckboxChange = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === currentItems.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(currentItems.map((item) => item.order_code));
    }
  };

  const handleSendWhatsApp = async () => {
    if (selectedRows.length === 0) {
      alert("No users selected. Please select at least one user.");
      return;
    }

    try {
      const selectedUsers = filteredList.filter((user) =>
        selectedRows.includes(user.order_code)
      );

      if (selectedUsers.length === 0) {
        alert("No users found in the selected date range.");
        return;
      }

      console.log("Sending WhatsApp Data:", selectedUsers); // Debugging
      let response = await axios.post(master.send_whatsapp_message, {
        users: selectedUsers,
      });

      console.log("API Response:", response.data); // Debugging
      if (response.data.success) {
        alert("WhatsApp messages sent successfully!");
      } else {
        // alert("Failed to send WhatsApp messages.");
        alert(`Failed: ${response.data.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error(err);
      alert("Error while sending WhatsApp messages.");
    }
  };

  const handleReset = () => {
    setFilters({
      order_code: "",
      tracking_number: "",
      shipping_courier: "",
      order_date: "",
      customer_name: "",
      phone_number: "",
      product: "",
      address: "",
      state: "",
      pincode: "",
    });
    setDateFilter({ fromDate: "", toDate: "" });
    loadData();
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Unicommerce Detail</h1>
      </div>

      <div className="row mt-3">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body pt-3">
              <div className="row mb-3">
                <div className="col-md-3">
                  <label>From Date:</label>
                  <Form.Control
                    type="date"
                    value={dateFilter.fromDate}
                    onChange={(e) =>
                      setDateFilter({ ...dateFilter, fromDate: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-3">
                  <label>To Date:</label>
                  <Form.Control
                    type="date"
                    value={dateFilter.toDate}
                    onChange={(e) =>
                      setDateFilter({ ...dateFilter, toDate: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-6 d-flex align-items-end">
                  <Button
                    variant="primary"
                    onClick={filterByDate}
                    className="me-2"
                  >
                    Submit
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={handleReset}
                    className="me-2"
                  >
                    Reset
                  </Button>
                  <Button variant="success" onClick={handleSendWhatsApp}>
                    Send WhatsApp
                  </Button>
                </div>
              </div>

              <Table striped bordered hover responsive>
                <thead>
                  <tr className="table-secondary">
                    <th>
                      <Form.Check
                        type="checkbox"
                        checked={
                          selectedRows.length === currentItems.length &&
                          currentItems.length > 0
                        }
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th>No.</th>
                    {Object.keys(filters).map((key) => (
                      <th key={key}>{key.replace("_", " ").toUpperCase()}</th>
                    ))}
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    {Object.keys(filters).map((key) => (
                      // <th key={key}>
                      //   <Form.Control
                      //     type="text"
                      //     placeholder={`Filter ${key.replace("_", " ")}`}
                      //     name={key}
                      //     value={filters[key]}
                      //     onChange={handleFilterChange}
                      //   />
                      // </th>
                      <th key={key}>
                        {key === "tracking_number" ? (
                          <>
                            <Form.Check
                              type="checkbox"
                              label="Tracking No."
                              checked={trackOnly}
                              onChange={() => setTrackOnly((prev) => !prev)}
                            />
                            <Form.Control
                              type="text"
                              placeholder={`Filter ${key.replace("_", " ")}`}
                              name={key}
                              value={filters[key]}
                              onChange={handleFilterChange}
                            />
                          </>
                        ) : (
                          <Form.Control
                            type="text"
                            placeholder={`Filter ${key.replace("_", " ")}`}
                            name={key}
                            value={filters[key]}
                            onChange={handleFilterChange}
                          />
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((unicommerce_detail, index) => (
                      <tr key={index}>
                        <td>
                          <Form.Check
                            type="checkbox"
                            checked={selectedRows.includes(
                              unicommerce_detail.order_code
                            )}
                            onChange={() =>
                              handleCheckboxChange(
                                unicommerce_detail.order_code
                              )
                            }
                          />
                        </td>
                        <td>{indexOfFirstItem + index + 1}</td>
                        {Object.keys(filters).map((key) => (
                          <td key={key}>
                            {key === "order_date" && unicommerce_detail[key]
                              ? new Date(
                                  unicommerce_detail[key]
                                ).toLocaleDateString("en-IN") // Or "en-US" as needed
                              : unicommerce_detail[key]}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <div className="card-footer d-flex justify-content-between align-items-center">
                <div>
                  Showing {indexOfFirstItem + 1} to{" "}
                  {Math.min(indexOfLastItem, filteredList.length)} of{" "}
                  {filteredList.length} entries
                </div>
                <nav aria-label="Page navigation">
                  <ul className="pagination mb-0">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        &laquo; Prev
                      </button>
                    </li>

                    {/* Page Dropdown */}
                    <li className="page-item">
                      <Form.Select
                        className="custom-pagination-dropdown"
                        value={currentPage}
                        onChange={(e) => setCurrentPage(Number(e.target.value))}
                      >
                        {Array.from({ length: totalPages }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            Page {i + 1}
                          </option>
                        ))}
                      </Form.Select>
                    </li>

                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        Next &raquo;
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default UnicommerceData;
